export default theme => ({
    buttonPreview: {
        padding: 10,
        border: `1px solid #DFE3E8`,
        marginLeft: -10,
        borderRadius: 5,
        fontWeight: 500
    }
})